import { HttpService } from "./HttpService";
import { URL } from "enum";
const URL_API = URL.BASE;

const TareasPendientesService = {
	async listar() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/tareas-pendientes");
		return respuesta.data;
	},
	async buscarPorId(tareaPendienteId) {
		const respuesta = await HttpService(URL_API).get(`/portal-colaborador/tareas-pendientes/${tareaPendienteId}`);
		return respuesta.data;
	},
	async firmarDocumento(datos) {
		const respuesta = await HttpService(URL_API).put(
			`/portal-colaborador/tareas-pendientes/firmar-documento`,
			datos
		);
		return respuesta.data;
	},
	async subirDocumento(data) {
		const respuesta = await HttpService(URL_API).post(
			`/portal-colaborador/tareas-pendientes/subir-documento`,
			data
		);
		return respuesta.data;
	},
	async aprobarDocumento(data) {
		const respuesta = await HttpService(URL_API).put(
			`/portal-colaborador/tareas-pendientes/aprobar-documento`,
			data
		);
		return respuesta.data;
	},
	async rechazarDocumento(data) {
		const respuesta = await HttpService(URL_API).put(
			`/portal-colaborador/tareas-pendientes/rechazar-documento`,
			data
		);
		return respuesta.data;
	},
};
export default TareasPendientesService;
